import { z } from "zod";
import { Meta } from "./base";

export const CreateSignedUrlSchema = z.object({
  size: z.number(),
  mimetype: z.string(),
  originalname: z.string(),
});

export const UploadMultipartFormSchema = z.object({
  acl: z.string(),
  bucket: z.string(),
  "X-Amz-Algorithm": z.string(),
  "X-Amz-Credential": z.string(),
  "X-Amz-Date": z.string(),
  key: z.string(),
  Policy: z.string(),
  "X-Amz-Signature": z.string(),
});

export const CreateSignedUrlResponseSchema = z.object({
  uuid: z.string().uuid(),
  url: z.string(),
  data: UploadMultipartFormSchema,
  file: z.string(),
});

export type ResponsePaginationType<T> = {
  data: T[];
  meta?: Meta;
  message?: string;
};

export type CreateSignedUrlInput = z.infer<typeof CreateSignedUrlSchema>;
export type CreateSignedUrlOutput = z.infer<typeof CreateSignedUrlResponseSchema>;
export type UploadMultipartFormType = z.infer<typeof UploadMultipartFormSchema>;
export interface UploadSignedUrlInput extends UploadMultipartFormType {
  file: File;
}
